import { IUser } from '../users';

export enum SalesCallKeys {
  arrivalTimeUtc = 'arrivalTimeUtc',
  brands = 'brands',
  businessEntityId = 'businessEntityId',
  contacts = 'contacts',
  createdAt = 'createdAt',
  date = 'date',
  departureTimeUtc = 'departureTimeUtc',
  duration = 'duration',
  firstCallFail = 'firstCallFail',
  nextVisitDate = 'nextVisitDate',
  nextVisitNotes = 'nextVisitNotes',
  nextVisitObjectives = 'nextVisitObjectives',
  notes = 'notes',
  objectives = 'objectives',
  salesCallId = 'salesCallId',
  salesCallMethodId = 'salesCallMethodId',
  salesCallTypeId = 'salesCallTypeId',
  userName = 'userName',
  salesDistrict = 'salesDistrict'
}

export interface ISalesCall {
  [SalesCallKeys.arrivalTimeUtc]: Date | string;
  [SalesCallKeys.brands]: string[];
  [SalesCallKeys.businessEntityId]: number;
  [SalesCallKeys.contacts]: number[];
  [SalesCallKeys.createdAt]: Date | string;
  [SalesCallKeys.date]: Date;
  [SalesCallKeys.departureTimeUtc]: Date | string;
  [SalesCallKeys.firstCallFail]: boolean;
  [SalesCallKeys.nextVisitDate]?: Date | null;
  [SalesCallKeys.nextVisitNotes]: string | null;
  [SalesCallKeys.nextVisitObjectives]: number[];
  [SalesCallKeys.notes]: string;
  [SalesCallKeys.objectives]: number[];
  [SalesCallKeys.salesCallMethodId]: number;
  [SalesCallKeys.salesCallTypeId]: number;
  [SalesCallKeys.userName]: string;
  [SalesCallKeys.salesDistrict]: string;
  readonly [SalesCallKeys.duration]: number;
  readonly [SalesCallKeys.salesCallId]: number;
  sid?: string;
  businessName?: string;
  accountNum: string | null;
}

export interface IFetchSalesCallApiResponse {
  salesCalls: ISalesCall[];
  users: IUser[];
}

export interface IMinSalesCall {
  [SalesCallKeys.arrivalTimeUtc]: Date | string | undefined;
  [SalesCallKeys.businessEntityId]: number | '';
  [SalesCallKeys.date]: Date | string | undefined;
  [SalesCallKeys.departureTimeUtc]: Date | string | undefined;
  [SalesCallKeys.notes]: string;
  name: string;
}

export interface IInfoCallRequest extends IMinSalesCall {
  [index: string]: any;
  zipcode: string;
}
